import { combineReducers } from 'redux';

import settingsReducer from './settings.reducer.js';
import themesReducer from './themes.reducers.js';
import dialogsReducer from './dialogs.reducer.js';

export default combineReducers({
  settings: settingsReducer,
  theme: themesReducer,
  dialogs: dialogsReducer
});
